import { ClientLambdaApi } from '@/api-client.js'

const massiveDownloadSaveConfig = async (body) => {
  const response = await ClientLambdaApi.post('/massive-download/user-config',
    body,
    { needTokenValidation: true })
  if (response.status !== 201) {
    throw new Error('Error al guardar la configuración')
  }
  return response
}
const massiveDownloadPostParameters = async (parameters) => {
  const response = await ClientLambdaApi.post('/massive-download',
    { parameters },
    { needTokenValidation: true })
  if (response.status !== 201) {
    throw new Error('Error al procesar el trabajo de archivo')
  }
  return response
}

const massiveDownloadGetConfigList = async () => {
  const response = await ClientLambdaApi.get('/md-get-user-config/')
  if (response.status !== 200) {
    throw new Error('Error al obtener las configuraciones')
  }
  return response.data
}

const massiveDownloadGetJobList = async () => {
  const response = await ClientLambdaApi.get('/massive-download-job-list/')
  if (response.status !== 200) {
    throw new Error('Error al obtener el listado de trabajos')
  }
  return response.data
}

export { massiveDownloadPostParameters, massiveDownloadSaveConfig, massiveDownloadGetConfigList, massiveDownloadGetJobList }



// WEBPACK FOOTER //
// ./src/app/massive_download/services/MassiveDownloadService.js